export { default } from './coupon-code-copy';